import { Button } from "flowbite-react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { P } from "@/shared/ui/typographies/paragraph";

type RefuseConfirmationProps = {
  sourceOrganization: string
  isMutating: boolean
  onConfirmRefuse: () => void
  onCancel: () => void
};

export const RefuseConfirmation = ({
  sourceOrganization,
  isMutating,
  onConfirmRefuse,
  onCancel,
}: RefuseConfirmationProps) => (
  <div className="space-y-4 rounded-lg border border-red-200 bg-red-50 p-4 dark:border-red-800 dark:bg-red-950/30" aria-live="polite">
    <div className="flex items-start gap-3">
      <AlertTriangle size={20} className="mt-0.5 shrink-0 text-red-600 dark:text-red-400" />
      <div className="space-y-2">
        <P size="sm" className="font-medium text-red-900 dark:text-red-200">
          Êtes-vous sûr de vouloir refuser ce transfert ?
        </P>
        <P size="sm" className="text-red-700 dark:text-red-300 tracking-wider text-pretty">
          En refusant, votre compte restera rattaché à
          {" "}
          <strong>{sourceOrganization}</strong>
          {" "}
          et aucune donnée ne sera transférée.
        </P>
      </div>
    </div>
    <div className="flex w-full justify-between gap-8">
      <Button
        color="red"
        size="sm"
        className="flex-1"
        onClick={onConfirmRefuse}
        disabled={isMutating}
      >
        {isMutating
          ? (
            <>
              <Loader2 size={14} className="mr-2 animate-spin" />
              Refus en cours...
            </>
          )
          : "Confirmer le refus"}
      </Button>
      <Button
        color="light"
        size="sm"
        className="flex-1"
        onClick={onCancel}
        disabled={isMutating}
      >
        Retour à la demande
      </Button>
    </div>
  </div>
);
